var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rd-legacy"},[_c('report-tools',{attrs:{"copy":""},on:{"copy":_vm.copyTables}}),_c('div',{ref:"host"},[_c(_vm.component,_vm._b({ref:"tab",tag:"component",on:{"switch-tab":(index) => _vm.$emit('switch-tab', index)}},'component',_vm.componentProps,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }